import React from "react";
import { Helmet } from "react-helmet";
import HomeSlider from "../components/home-slider";
import HomeSolutions from "../components/home-solutions";
import HomeTravelcarmaFor from "../components/home-travelcarma-for";
import HomePlatform from "../components/home-platform";
import HomeSuppliers from "../components/home-suppliers";
import HomeCustomers from "../components/home-customers";
import HomeWhatDifferent from "../components/home-what-different";
import HomeBlog from "../components/home-blog";

const Index = () => {
  return (
    <div>
      <Helmet>
        <title>
          AI-First Travel Technology Company | Bespoke Travel Software Solutions
          | TravelCarma
        </title>
        <meta
          name="keywords"
          content="AI-First Travel Technology, Travel Technology Company, Travel Software Solutions, Bespoke Travel Software Development, Travel Agency Software, B2B Booking Engine, B2C Travel Portal, Travel API Integration, Supplier Integration, Travel CRM, Back Office Travel System, Travel Automation Solutions"
        />
        <meta
          name="description"
          content="TravelCarma is an AI-first travel technology company helping travel agencies, tour operators, DMCs and wholesalers AI-enable workflows, manage and extend legacy systems, integrate supplier APIs, and build bespoke travel software solutions around existing platforms."
        />
      </Helmet>
      <HomeSlider />
      <div className="home-body">
        <div>
          <HomeSolutions />
          <HomeTravelcarmaFor />
          <HomePlatform />
          <HomeSuppliers />
          <HomeCustomers />
          <HomeWhatDifferent />
          <HomeBlog />
        </div>
      </div>
    </div>
  );
};

export default Index;
